import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTreeNestedDataSource } from '@angular/material/tree';

@Component({
  selector: 'app-dialog-engin',
  templateUrl: './dialog-engin.component.html',
  styleUrls: ['./dialog-engin.component.scss']
})
export class DialogEnginComponent {
  dataSource = new MatTreeNestedDataSource<any>();
  refItems!: any[];
  constructor(
    public dialogRef: MatDialogRef<DialogEnginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
